"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const AppSettings_1 = __importStar(require("../AppSettings"));
const PackageDetails_1 = require("../PackageDetails");
const DataScrubber_1 = require("./DataScrubber");
const types_1 = require("./types");
class Log {
    constructor(sinks) {
        this._sinks = [];
        this._globalProps = {};
        this._sinks = [...sinks];
        // any missing configuration accessed by other code should be captured with Log.info
        (0, AppSettings_1.setMissingConfigurationLogger)(this.info.bind(this));
    }
    debug(message, options) {
        this._forwardLog(createLogEntry("debug", message, this._globalProps, options));
    }
    info(message, options) {
        this._forwardLog(createLogEntry("info", message, this._globalProps, options));
    }
    warn(message, options) {
        this._forwardLog(createLogEntry("warn", message, this._globalProps, options));
    }
    error(message, options) {
        this._forwardLog(createLogEntry("error", message, this._globalProps, options));
    }
    addGlobalProperties(props) {
        this._globalProps = props;
    }
    _forwardLog(logEntry) {
        // run the log entry through data scrubbing. if we find ourselves
        // needing/wanting to run lots of processing on this object, and we
        // want that to be dynamic/configurable, then we ought to consider
        // exposing a slot where you can provide these log enrichers,
        // e.g. Log.addEnricher(AThingThatMutatesLogEntry)
        const scrubbedLogEntry = DataScrubber_1.DataScrubber.scrubLogEntry(logEntry);
        this._sinks.forEach((sink, idx, allSinks) => {
            try {
                sink.next(scrubbedLogEntry);
            }
            catch (err) {
                // allow these errors through so that we're alerted to unexpected logs in tests
                if (err instanceof types_1.TestAssertUnexpectedLogError) {
                    throw err;
                }
                // remove the sink that threw from the collection of sinks, so
                // that we don't run into this situation again
                allSinks.splice(idx, 1);
                // raise an error, this will most likely be picked up by at least one
                // of the other remainins sinks. but it is possible, though unlikely
                // that we might never see error if all sinks have been removed
                this.error(new types_1.LogSinkError("A LogSink unexpectedly threw whilst receiving a LogEntry. It has now been disabled."), {
                    originalException: err,
                    tags: {
                        sink: sink.constructor.name,
                    },
                    context: [
                        {
                            name: "Scrubbed LogEntry",
                            data: scrubbedLogEntry,
                        },
                    ],
                });
            }
        });
    }
}
class Logger {
    static create(sinks = []) {
        this._sinks = new Set([...sinks]);
        Logger._logger = new Log([...this._sinks]);
        return Logger._logger;
    }
    static addSink(sink) {
        if (Logger._logger === null) {
            throw new Error("NotInitialisedError: A logger has not been created, did you forget to call Logger.create()");
        }
        return Logger.create([...this._sinks, sink]);
    }
    static removeSink(sink) {
        if (this._sinks.has(sink)) {
            this._sinks.delete(sink);
        }
        return Logger.create([...this._sinks]);
    }
    static removeAllSinks() {
        return Logger.create();
    }
}
exports.Logger = Logger;
Logger._logger = null;
Logger._sinks = new Set();
function isWebView() {
    var _a;
    // handle SSR in NextJS where window might not be defined
    if (typeof window === "undefined")
        return false;
    return !!((_a = window === null || window === void 0 ? void 0 : window.chrome) === null || _a === void 0 ? void 0 : _a.webview);
}
function createLogEntry(level, message, globalProps, options) {
    return {
        message,
        level,
        tags: Object.assign(Object.assign({}, globalProps), decorateTags(options === null || options === void 0 ? void 0 : options.tags)),
        contexts: options === null || options === void 0 ? void 0 : options.context,
        originalException: options === null || options === void 0 ? void 0 : options.originalException,
        fingerprint: options === null || options === void 0 ? void 0 : options.errorGroup,
    };
}
/**
 * Given a LogContext, furnish the tags object with some additional properties
 * for added helpfulness
 *
 * @param {LogContext} options a LogContext for the current log event
 */
function decorateTags(options) {
    const sourceBranchName = AppSettings_1.default.getBranchName();
    const loggerTags = {
        inApp: true,
        "Log.package": PackageDetails_1.NAME,
        "Log.version": PackageDetails_1.VERSION,
    };
    if (sourceBranchName && !sourceBranchName.includes("trunk")) {
        loggerTags["Branch"] = sourceBranchName;
    }
    if (isWebView()) {
        loggerTags["WebView"] = true;
    }
    const finalTags = options !== undefined
        ? Object.assign(Object.assign({}, loggerTags), options) : Object.assign({}, loggerTags);
    return finalTags;
}
//# sourceMappingURL=index.js.map